import {
  TableView,
  type TableViewProps,
} from 'components/Table/components/TableView';
import type { TableCellContext } from 'components/Table/model/TableCellContext';
import type { TableOuterStateProps } from 'components/Table/model/TableModel';
import { useTable } from 'components/Table/model/useTable';
import type { JSX } from 'react';

export type TableProps<TRow> = TableViewProps &
  TableOuterStateProps<TRow> & {
    onRestoreSettings?: () => void;
    tableCellContext?: Partial<TableCellContext>;
  };

export const Table = <TRow,>(props: TableProps<TRow>): JSX.Element => {
  const model = useTable({
    id: props.id,
    bulkActions: props.bulkActions,
    canRowBeSelected: props.canRowBeSelected,
    columns: props.columns,
    data: props.data,
    description: props.description,
    externalFilters: props.externalFilters,
    onRemoveFilters: props.onRemoveFilters,
    initialSelectedRows: props.initialSelectedRows,
    loadRowIdsForSelectAll: props.loadRowIdsForSelectAll,
    loading: props.loading,
    menuItems: props.menuItems,
    onChangeFilter: props.onChangeFilter,
    onChangeIntentFilter: props.onChangeIntentFilter,
    onRequestRowRange: props.onRequestRowRange,
    onRestoreSettings: props.onRestoreSettings,
    onSubmitFilters: props.onSubmitFilters,
    externalSettings: props.externalSettings,
    rowIdField: props.rowIdField,
    selectedFilterPreset: props.selectedFilterPreset,
    onSelectFilterPreset: props.onSelectFilterPreset,
    sort: props.sort,
    simpleFilterFields: props.simpleFilterFields,
    simpleFilterFieldsSubmitted: props.simpleFilterFieldsSubmitted,
    onSortChange: props.onSortChange,
    rowCount: props.rowCount,
    rowCountMore: props.rowCountMore,
    tableCellContext: props.tableCellContext,
    title: props.title,
    titleEndAdornment: props.titleEndAdornment,
    disableRestoreSettings: props.disableRestoreSettings,
    disableContextMenu: props.disableContextMenu,
    disableStickyColumn: props.disableStickyColumn,
    equalWidthColumns: props.equalWidthColumns,
    hideAutoSizing: props.hideAutoSizing,
    noDataBox: props.noDataBox,
  });

  return (
    <TableView
      model={model}
      // TableViewProps
      autoHeightLimit={props.autoHeightLimit}
      borderless={props.borderless}
      className={props.className}
      rowHeight={props.rowHeight}
      hideFooter={props.hideFooter}
      hideTitle={props.hideTitle}
      disableTableRowDetail={props.disableTableRowDetail}
      rowDragState={props.rowDragState}
      onRowMouseMove={props.onRowMouseMove}
      onRowMouseLeave={props.onRowMouseLeave}
    />
  );
};
